import { factory as flaxiosFactory } from 'Utils/flaxios';
import { setupCache } from 'axios-cache-adapter';

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  // Bound the in-memory store (default is unlimited); oldest evicted = a miss.
  limit: 100,
  exclude: {
    query: false,
  },
});

export const sitemapFactory = () =>
  flaxiosFactory({
    baseURL: `/api/v2/sitemap`,
    adapter: cache.adapter,
  });

export default sitemapFactory();
